/*
 * Copyright (c) 2020 Staffino, s.r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Martin Komara, August 2020
 */

import React, { useCallback, useEffect, useReducer } from 'react';
import { Trans } from 'react-i18next';
import { Box, Link, Paragraph, styled } from '@staffino/primitive-controls';
import BodyPortal from './body-portal';

const Container = styled(Box)({
  position: 'fixed',
  backgroundColor: '#4da1ff',
  padding: '2.5rem',
  bottom: 0,
  left: 0,
  right: 0,
});

type Props = {
  timeout?: number;
  onRestart?: () => void;
  onCancel?: () => void;
};
const FlowRestarterUi = ({ timeout = 30, onRestart, onCancel }: Props) => {
  const [remaining, tick] = useReducer((x) => x - 1, timeout);
  const handleTimer = useCallback(() => {
    tick();
    if (remaining === 1) {
      onRestart?.();
    }
  }, [onRestart, remaining]);
  useEffect(() => {
    const timer = setInterval(handleTimer, 1000);
    return () => {
      clearInterval(timer);
    };
  }, [handleTimer]);

  return (
    <BodyPortal>
      <Container flexDirection={'row' as const} alignItems="center">
        <Paragraph color="white" flexShrink={1}>
          <Trans count={remaining}>
            The form will reset in {{ remaining }} second
          </Trans>
        </Paragraph>
        <Paragraph flexDirection={'row' as const} ml="auto" textAlign="right">
          <Link color="white" onClick={() => onRestart?.()} mr="0.5rem">
            <Trans>Restart Now</Trans>
          </Link>
          <Link color="white" onClick={() => onCancel?.()}>
            <Trans>Stay here</Trans>
          </Link>
        </Paragraph>
      </Container>
    </BodyPortal>
  );
};

export default FlowRestarterUi;
